<template>
  <div class="websiteinfo-container">
    <el-card class="box-card" shadow="always">
      <el-table
        :data="tableData"
        height="600"
        style="width: 100%"
        stripe>
        <el-table-column
          type="index"
          width="50">
        </el-table-column>
        <el-table-column
          prop="title"
          width="300"
          show-overflow-tooltip
          :label="tName">
          <template slot-scope="scope">
            <el-link type="primary" :href='scope.row.url' target="_blank">{{ scope.row.title }}</el-link>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
  </div>
</template>

<script>
import { getWebsites } from '../api/website'
export default {
  name: 'websiteinfo',
  data () {
    return {
      tableData: [],
      activeName: ''
    }
  },
  props: {
    tName: {
      type: String,
      default: ''
    },
    tId: {
      type: String,
      default: ''
    }
  },
  methods: {
    getWebsitesTable (type) {
      getWebsites(type).then(response => {
        this.tableData = response.data
      })
    }
  },
  mounted () {
    this.getWebsitesTable(this.tId)
  }
}
</script>

<style scoped>
.websiteinfo-container {
  padding: 20px;
  max-width: 1400px;
  margin: 0 auto;
}
.box-card {
  width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/view/websiteinfo.vue